export const enCa: {[key: string]: string} = {

	icon_language: 'language',
	icon_login: 'person_add',
	icon_logout: 'exit_to_app',
	icon_user: 'person',
	icon_user_guest: 'person_outline',

};
